import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IReportsAdminRefferalPendingDetail_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IReportsAdminRefferalPendingDetail_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  KuikaB2B_OrderSalesCustomerDetailMobile: any[];
  KuikaB2B_OrderSalesCustomerDetailMobile_dummy: any[];
  ExportExcel: any;
  ExportExcel_dummy: any;
  Notify: boolean;
  Notify_dummy: boolean;
}

export class ReportsAdminRefferalPendingDetail_ScreenBase extends React.PureComponent<
  IReportsAdminRefferalPendingDetail_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  reportsadminrefferalpendingdetail_198108_value_kuikaTableRef: React.RefObject<any>;
  reportsadminrefferalpendingdetail_811321_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 927868,
          PropertyName: "value",
          Value: "Rapor Detay",
          TagName: "Label17_value",
        },
        {
          Id: 817950,
          PropertyName: "value",
          Value: "Bekleyen Sipariş Raporu Detay",
          TagName: "Label2_value",
        },
        {
          Id: 799205,
          PropertyName: "label",
          Value: "Export",
          TagName: "Button3_label",
        },
        {
          Id: 69667,
          PropertyName: "value",
          Value: "Koleksiyon Adı",
          TagName: "Label3_value",
        },
        {
          Id: 687697,
          PropertyName: "value",
          Value: "Desen Adı",
          TagName: "Label4_value",
        },
        {
          Id: 750303,
          PropertyName: "value",
          Value: "Ebat Adı",
          TagName: "Label6_value",
        },
        {
          Id: 463962,
          PropertyName: "value",
          Value: "Miktar",
          TagName: "Label5_value",
        },
        {
          Id: 47477,
          PropertyName: "value",
          Value: "Metrekare",
          TagName: "Label7_value",
        },
        {
          Id: 297341,
          PropertyName: "value",
          Value: "Bekleyen Miktar",
          TagName: "Label8_value",
        },
        {
          Id: 244116,
          PropertyName: "value",
          Value: "Bekleyen Metrekare",
          TagName: "Label15_value",
        },
        {
          Id: 20412197,
          PropertyName: "d9a9067e-3f9c-b9ae-324b-f467fc75d2dd_confirmation",
          Value: "Raporu Excel Olarak Almak İstiyor Musunuz?",
          TagName: "ExportExcel_confirmation",
          IsConfirmation: true,
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 927868,
          PropertyName: "value",
          Value: "Report Detail",
          TagName: "Label17_value",
        },
        {
          Id: 817950,
          PropertyName: "value",
          Value: "Pending Order Report Details",
          TagName: "Label2_value",
        },
        {
          Id: 799205,
          PropertyName: "label",
          Value: "Export",
          TagName: "Button3_label",
        },
        {
          Id: 69667,
          PropertyName: "value",
          Value: "Collection Name",
          TagName: "Label3_value",
        },
        {
          Id: 687697,
          PropertyName: "value",
          Value: "Pattern Name",
          TagName: "Label4_value",
        },
        {
          Id: 750303,
          PropertyName: "value",
          Value: "Size Name",
          TagName: "Label6_value",
        },
        {
          Id: 463962,
          PropertyName: "value",
          Value: "Quantity",
          TagName: "Label5_value",
        },
        {
          Id: 47477,
          PropertyName: "value",
          Value: "Square meters",
          TagName: "Label7_value",
        },
        {
          Id: 297341,
          PropertyName: "value",
          Value: "Pending Quantity",
          TagName: "Label8_value",
        },
        {
          Id: 244116,
          PropertyName: "value",
          Value: "Pending Square Meters",
          TagName: "Label15_value",
        },
        {
          Id: 83877063,
          PropertyName: "d9a9067e-3f9c-b9ae-324b-f467fc75d2dd_confirmation",
          Value: "Do you want to receive the report as an Excel file?",
          TagName: "ExportExcel_confirmation",
          IsConfirmation: true,
        },
        {
          Id: 9931246,
          PropertyName: "7cf7a687-0877-8255-3ec0-a50afc61daf2_notify",
          Value: "Report Successfully Generated",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "febd4e82-6194-4aca-8eb2-be2af6de6b00",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 927868, PropertyName: "value", Value: "Rapor Detay" },
        {
          Id: 817950,
          PropertyName: "value",
          Value: "Bekleyen Sipariş Raporu Detay",
        },
        { Id: 799205, PropertyName: "label", Value: "Export" },
        { Id: 203141, PropertyName: "title", Value: "Title" },
        { Id: 69667, PropertyName: "value", Value: "Koleksiyon Adı" },
        { Id: 687697, PropertyName: "value", Value: "Desen Adı" },
        { Id: 750303, PropertyName: "value", Value: "Ebat Adı" },
        { Id: 463962, PropertyName: "value", Value: "Miktar" },
        { Id: 47477, PropertyName: "value", Value: "Metrekare" },
        { Id: 297341, PropertyName: "value", Value: "Bekleyen Miktar" },
        { Id: 244116, PropertyName: "value", Value: "Bekleyen Metrekare" },
        {
          Id: 27537,
          PropertyName: "value",
          Value: "[datafield:productatt03desc]",
        },
        {
          Id: 388399,
          PropertyName: "value",
          Value: "[datafield:productatt05desc]",
        },
        {
          Id: 165864,
          PropertyName: "value",
          Value: "[datafield:productatt07desc]",
        },
        { Id: 530861, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 472795, PropertyName: "value", Value: "[datafield:qty2]" },
        {
          Id: 380614,
          PropertyName: "value",
          Value: "[datafield:remainingorderqty1]",
        },
        {
          Id: 312715,
          PropertyName: "value",
          Value: "[datafield:remainingorderqty2]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.reportsadminrefferalpendingdetail_198108_value_kuikaTableRef =
      React.createRef();
    this.reportsadminrefferalpendingdetail_811321_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      KuikaB2B_OrderSalesCustomerDetailMobile: [],
      ExportExcel: "",
      Notify: false,
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "reportsadminrefferalpendingdetail",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ReportsAdminRefferalPendingDetailPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.ReportsAdminRefferalPendingDetailPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "reportsadminrefferalpendingdetail",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BAdmin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "reportsadminrefferalpendingdetail",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ReportsAdminRefferalPendingDetailPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ReportsAdminRefferalPendingDetailPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ReportsAdminRefferalPendingDetailPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      orderNumberWS_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.OrderNumber ??
          this.props.screenInputs.ordernumber,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsAdminRefferalPendingDetail/ReportsAdminRefferalPendingDetailPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_OrderSalesCustomerDetailMobile =
      result?.data.kuikaB2B_OrderSalesCustomerDetailMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsAdminRefferalPendingDetailPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsAdminRefferalPendingDetailPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_198108 =
      stateVars.KuikaB2B_OrderSalesCustomerDetailMobile ??
      this.state.KuikaB2B_OrderSalesCustomerDetailMobile;
    formVars.reportsadminrefferalpendingdetail_811321_total =
      ReactSystemFunctions.value(
        this,
        stateVars.KuikaB2B_OrderSalesCustomerDetailMobile !== undefined
          ? stateVars.KuikaB2B_OrderSalesCustomerDetailMobile?.length > 0
            ? stateVars.KuikaB2B_OrderSalesCustomerDetailMobile[0].totalRows
            : null
          : this.state.KuikaB2B_OrderSalesCustomerDetailMobile?.length > 0
          ? this.state.KuikaB2B_OrderSalesCustomerDetailMobile[0].totalRows
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ReportsAdminRefferalPendingDetailComponent_111407_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsAdminRefferalPendingDetailComponent_799205_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      value_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          this.state.KuikaB2B_OrderSalesCustomerDetailMobile
        ),
        "any"
      ),
      header_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      footer_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      columns_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "ProductAtt03Desc,ProductAtt05Desc,ProductAtt07Desc,Qty1,Qty2,RemainingOrderQty1,RemainingOrderQty2",
          "string"
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "d9a9067e_3f9c_b9ae_324b_f467fc75d2dd_confirmation",
        this.defaultML,
        "Raporu Excel Olarak Almak İstiyor Musunuz?"
      ),
      "poppins",
      "Confirmation",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "ReportsAdminRefferalPendingDetail/ReportsAdminRefferalPendingDetailComponent_799205_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.ExportExcel = result?.data.exportExcel;
      ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ReportsAdminRefferalPendingDetailComponent_799205_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsAdminRefferalPendingDetailComponent_799205_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "7cf7a687_0877_8255_3ec0_a50afc61daf2_notify",
        this.defaultML,
        "Rapor Başarıyla Oluşturuldu"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ReportsAdminRefferalPendingDetailPageInit();
    }
  }
}
